import React, { Fragment } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import LoadingSpinner from './../../components/shared/LoadingSpinner.component'
import UpcomingRaceWinners from './components/UpcomingRaceWinners/UpcomingRaceWinners.component.jsx'
import RecentRaceWinners from './components/RecentRaceWinners/RecentRaceWinners.component.jsx'
import WinnerSpotlight from './components/WinnerSpotlight/WinnerSpotlight.component.jsx'
import CurrentContestants from './components/CurrentContestants/CurrentContestants.component.jsx'
import RoyalRingShowcase from './components/RoyalRingShowcase/RoyalRingShowcase.component.jsx'
import Store from './store'

import './RaceToTheRing.page.scss'

class RaceToTheRingPage extends React.Component {
  componentDidMount() {
    // Fetch data when component mounts
    Store.fetch()
  }

  goTo = path => {
    this.props.history.push(path)
  }

  render() {
    return (
      <Fragment>
        <DashboardLayout>
          <main id='RaceToTheRingPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <PageHeading
                label='Race to the Ring'
                url={this.props?.match?.url}
                from={this.props?.location?.state?.from}
                goTo={this.goTo}
              />
            </MDBContainer>
            <MDBContainer fluid>
              <div className='race-to-the-ring-content'>
                <div className='mt-5 mb-3'>
                  <RoyalRingShowcase />
                </div>
                <div className='mt-5 mb-3'>
                  <RecentRaceWinners />
                </div>
                <div className='mt-5 mb-3'>
                  <UpcomingRaceWinners />
                </div>
                <div className='mt-5 mb-3'>
                  <WinnerSpotlight />
                </div>
                <div className='mt-5 mb-3'>
                  <CurrentContestants />
                </div>
              </div>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default RaceToTheRingPage
